export default {
    categories: [],
  }
  